import React, { useEffect, useState } from 'react'
import confetti from 'canvas-confetti';
import { Form, Input, Button, Select, Typography, message, Modal, Radio, Spin, Alert, Checkbox, Tooltip } from 'antd'; // Añadir Alert, Checkbox, Tooltip
import { CheckCircleOutlined, WarningOutlined, BulbOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Ciudades from '../../ciudades/ciudades';
import axios from 'axios';
import './SendClient.css';

const { Option } = Select;
const { Text } = Typography;

const calcularPrecioConComision = (precio) => {
  const precioBase = parseFloat(precio);
  const comision = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
  const comisionDecimal = comision / 100;
  return precioBase + (precioBase * comisionDecimal);
};

const SendClientPage = (props) => {
  const [form] = Form.useForm();
  const [costo, setCosto] = useState(null);
  const [precioProveedor, setPrecioProveedor] = useState(null);
  const [transportadora, setTransportadora] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [inputValue, setInputValue] = useState(1);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [loading, setLoading] = useState(false); // Estado para controlar la rueda de carga
  const [subtotal, setSubtotal] = useState(0);
  const [idsucursal, setIdsucursal] = useState('');
  const [selectedBodega, setSelectedBodega] = useState(null);
  const [selectedBodegaStock, setSelectedBodegaStock] = useState(null);
  const [statusWhatsapp, setStatusWhatsapp] = useState(false);
  const [showMultiProviderAlert, setShowMultiProviderAlert] = useState(false);
  const [totalProviders, setTotalProviders] = useState(0);
  const [modalMessage, setModalMessage] = useState(null); // Añadir estado para mensajes modales
  const [seguro99Enabled, setSeguro99Enabled] = useState(true); // Estado para Seguro 99
  const [seguro99PlusEnabled, setSeguro99PlusEnabled] = useState(false); // Estado para Seguro 99 Plus
  const [selectedTamanoGuia, setSelectedTamanoGuia] = useState('2'); // Estado para tamaño de guía
  const [seguroDisabledByPercentage, setSeguroDisabledByPercentage] = useState(false); // Estado para controlar si el seguro está desactivado por porcentaje
  const [desactivateSeguroPlus, setDesactivateSeguroPlus] = useState(false); // Estado para desactivar seguro plus
  const [isVisibleModalWarning, setIsVisibleModalWarning] = useState(false); // Estado para modal de advertencia

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  

  const actualizarPrecioTransportadora = (index) => {
    const transportadoraName = envios[index];
    const cotizacion = cotizaciones[transportadoraName];
    if (cotizacion) {
      // Reiniciamos el total y calculamos todo desde cero
      let total = 0;
      total += cotizacion.valor || 0;
      total += cotizacion.valor_contrapago || 0;
      total += cotizacion.comision_interna || cotizacion.valor_interna || 0;
      total += cotizacion.sobreflete || 0;
      // Solo agregamos el seguro99 si está habilitado
      if (seguro99Enabled) {
        total += cotizacion.seguro99 || 0;
      }
      setTransportadora(total);
    }
  };

  const handleSeguro99Change = (checked) => {
    if (checked && seguroDisabledByPercentage) {
      setIsVisibleModalWarning(true);
      return;
    }

    if (checked && seguro99PlusEnabled) {
      // Si se activa seguro99 y seguro99Plus está activo, desactivar seguro99Plus
      setSeguro99PlusEnabled(false);
      form.setFieldsValue({ seguro99plus: false });
      setFormValues(prev => ({ ...prev, seguro99plus: false }));
    }

    setSeguro99Enabled(checked);
    form.setFieldsValue({ seguro99: checked });
    setFormValues(prev => ({ ...prev, seguro99: checked }));
    
    // Actualizar el precio de la transportadora si hay una seleccionada
    if (selectedImage !== null) {
      actualizarPrecioTransportadora(selectedImage);
    }
  };

  const handleSeguro99PlusChange = (checked) => {
    if (checked && desactivateSeguroPlus) {
      setSeguro99PlusEnabled(false);
      form.setFieldsValue({ seguro99plus: false });
      setFormValues(prev => ({ ...prev, seguro99plus: false }));
      return;
    }

    if (checked && seguro99Enabled) {
      // Si se activa seguro99Plus y seguro99 está activo, desactivar seguro99
      setSeguro99Enabled(false);
      form.setFieldsValue({ seguro99: false });
      setFormValues(prev => ({ ...prev, seguro99: false }));
    }

    setSeguro99PlusEnabled(checked);
    form.setFieldsValue({ seguro99plus: checked });
    setFormValues(prev => ({ ...prev, seguro99plus: checked }));
  };

  useEffect(() => {
    fetchModalMessage();
  }, []);

  const { 
    estadoBodega, 
    inventarioBodega, 
    cart = [], // Add default value
    isCartCheckout = false, // Add default value
    variaciones = [],       // <-- leer la prop
    idSucursal = null       // <-- nuevo prop
  } = props;

  const usuario_id = localStorage.getItem('usuario_id');

  useEffect(() => {
    // Si recibimos idSucursal por props, lo usamos directamente
    if (idSucursal) {
      setIdsucursal(idSucursal);
      return;
    }
    // Fallback: buscar por usuario si no viene por props
    const fetchSucursalId = async () => {
      try {
        const response = await axios.get(`https://99envios.app/api/online/sucursal-codigo-sucursal/${usuario_id}`);
        setIdsucursal(response.data);
      } catch (error) {
        console.error('Error al obtener el ID de la sucursal', error);
      }
    };

    if (usuario_id) {
      fetchSucursalId();
    }
  }, [usuario_id, idSucursal]);

  useEffect(() => {
    const fetchSucursalData = async () => {
      try {
        const sucursalResponse = await axios.get(`https://99envios.app/api/online/sucursal/${usuario_id}`);
        setStatusWhatsapp(sucursalResponse.data.status_whatsapp === 1);
        console.log('Status WhatsApp:', sucursalResponse.data.status_whatsapp);
        const porcentajeEstado5 = sucursalResponse.data.porcentaje_estado_5;

         if (porcentajeEstado5 >= 0.4) {
           setSeguroDisabledByPercentage(true);
           setDesactivateSeguroPlus(true);
         } else if (porcentajeEstado5 >= 0.35) {
           setDesactivateSeguroPlus(true);
         } else {
           setSeguroDisabledByPercentage(false);
           setDesactivateSeguroPlus(false);
         }
      } catch (error) {
        console.error('Error fetching sucursal data:', error);
      }
    };

    if (idsucursal) {
      fetchSucursalData();
    }
  }, [idsucursal]);

  useEffect(() => {
    // Solo mostrar la alerta de múltiples proveedores si es checkout de carrito
    // y hay más de un proveedor
    if (isCartCheckout && cart && cart.length > 0) {
      const uniqueProviders = [...new Set(cart.map(item => item.provider))];
      setTotalProviders(uniqueProviders.length);
      if (uniqueProviders.length > 1) {
        setShowMultiProviderAlert(true);
      }
    }
  }, [isCartCheckout, cart]);

  const [cotizaciones, setCotizaciones] = useState({
    coordinadora: { mensaje: '', valor: 0, valorContrapago: 0, comisionInterna: 0, sobreflete: 0 },
    interrapidisimo: { mensaje: '', valor: 0, valorContrapago: 0, comisionInterna: 0, sobreflete: 0 },
    servientrega: { mensaje: '', valor: 0, valorContrapago: 0, comisionInterna: 0, sobreflete: 0 },
    tcc: { mensaje: '', valor: 0, valorContrapago: 0, comisionInterna: 0, sobreflete: 0 }
  });
  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    notes: '',
    payment: '',
    product: '',
    quantity: 1,
    salePrice: 0,
    store: '',
    aplicaContrapago: true  // Nuevo campo para AplicaContrapago
  });
  const [producto, setProducto] = useState({
    id_producto: '',
    id_sucursal: '',
    id_categoria: '',
    precio_proveedor: '',
    precio_sugerido: '',
    cantidad_disponible: '',
    created_at: '',
    descripcion_producto: '',
    estado_variacion: '',
    imagenes: [],
    informacion_adicional: '',
    nombre_producto: '',
    peso_producto: '',
    sku: '',
    updated_at: '',
    variaciones: []
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orderResponse, setOrderResponse] = useState(null);

  const current = new Date();
    const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                          ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                           current.getFullYear();

        const cotizacionData = {
        destino: {
          nombre: "",
          codigo: formValues.city,
        },
        origen: {
          nombre: "",
          codigo: "",
        },
        IdTipoEntrega: 1,
        IdServicio: 1,
        peso: isCartCheckout 
          ? cart.reduce((total, item) => total + (Number(item.peso_producto || 1) * item.quantity), 0)
          : (Number(props.peso_producto || 1) * formValues.quantity),
        largo: 1,
        ancho: 1,
        alto: 1,
        fecha: formattedDate,
        AplicaContrapago: formValues.aplicaContrapago,
        valorDeclarado: isCartCheckout
          ? cart.reduce((total, item) => total + (item.suggestedPrice * item.quantity), 0)
          : formValues.salePrice * formValues.quantity,
        seguro99: seguro99Enabled,
        seguro99plus: seguro99PlusEnabled,
      };

  const images = [
    '/Images/coordi.png',
    '/Images/inter.png',
    '/Images/servi.png',
    '/Images/tcc.svg'
  ];

  const envios = [
    'coordinadora',
    'interrapidisimo',
    'servientrega',
    'tcc'
  ];

  const handleChange = (value) => {
    if (isCartCheckout) {
      setInputValue(value);
      form.setFieldsValue({ quantity: value });
      return;
    }
  
    // Only check warehouse when estadoBodega is true
    if (estadoBodega && inventarioBodega.length > 0 && (selectedBodegaStock === null || selectedBodegaStock === undefined)) {
      message.error("Por favor seleccione una bodega para revisar el stock disponible");
      return;
    }
  
    const maxStock = estadoBodega 
      ? selectedBodegaStock 
      : (producto?.cantidad_disponible || props.stock);
      
    if (maxStock === undefined || maxStock === null) {
      message.error('Revise el stock disponible');
      return;
    }
  
    if (value < 1 || value > maxStock) {
      message.error(`La cantidad debe estar entre 1 y ${maxStock}`);
      return;
    }
    setInputValue(value);
    form.setFieldsValue({ quantity: value });
  };


  function formatCurrency(value, locale = 'es-CO', currency = 'COP') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  useEffect(() => {
    if (!isCartCheckout) { // Single product
      if (props.precioProveedor != null) {
        // Use passed props instead of fetching
        setPrecioProveedor(props.precioProveedor);
        setCosto(props.suggestedPrice);
        setProducto({
          id_producto: props.prodID,
          precio_proveedor: props.precioProveedor,
          precio_sugerido: props.suggestedPrice,
          nombre_producto: props.name,
          variaciones: variaciones    // <-- usar aquí
        });
        form.setFieldsValue({
          salePrice: calcularPrecioConComision(props.suggestedPrice),
          product: props.name,
          notes: ''
        });
        // Update formValues so the product name appears in the order summary
        setFormValues(prev => ({
          ...prev,
          salePrice: calcularPrecioConComision(props.suggestedPrice),
          product: props.name
        }));
      } else {
        // ...existing API fetch logic...
        const fetchProducts = async () => {
          setLoading(true);
          try {
            const { data } = await axios.get('https://api.99envios.app/api/inventarios');
            const foundProduct = data.find(prod => prod.id_producto === props.prodID) || {
              precio_sugerido: 0,
              precio_proveedor: 0,
              nombre_producto: '',
              descripcion_producto: '',
              variaciones: [] // Ensure default for API response fallback too
            };
            
            setProducto(foundProduct);
            setCosto(foundProduct.precio_sugerido);
            setPrecioProveedor(foundProduct.precio_proveedor);
            form.setFieldsValue({
              salePrice: calcularPrecioConComision(foundProduct.precio_sugerido),
              product: foundProduct.nombre_producto,
              notes: foundProduct.descripcion_producto
            });
            // Also update formValues with fetched product info
            setFormValues(prev => ({
              ...prev,
              salePrice: calcularPrecioConComision(foundProduct.precio_sugerido),
              product: foundProduct.nombre_producto
            }));
          } catch (error) {
            console.error('Error al cargar productos:', error);
            setProducto({});
          } finally {
            setLoading(false);
          }
        };
        fetchProducts();
      }
    }
  }, [isCartCheckout, props.prodID, props.precioProveedor, props.suggestedPrice, props.name, form]);

  const onValuesChangePedido = (changedValues, allValues) => {
    if (changedValues.salePrice || changedValues.quantity) {
      const newSalePrice = Number(changedValues.salePrice || allValues.salePrice);
      const newQuantity = Number(changedValues.quantity || allValues.quantity);
      const newSubtotal = newSalePrice * newQuantity;
      setSubtotal(newSubtotal);
      setFormValues({ ...allValues, salePrice: newSalePrice, quantity: newQuantity });
      handleAutomaticRequote(newSubtotal, allValues);
    } else {
      setFormValues(allValues);
    }
    calculateTotal(allValues);
  };

  const handleAutomaticRequote = async (newSubtotal, currentFormValues) => {
    setLoading(true);
    try {
      const pesoTotal = isCartCheckout 
        ? cart.reduce((total, item) => total + (Number(item.peso_producto || 1) * item.quantity), 0)
        : (Number(props.peso_producto || 1) * Number(currentFormValues.quantity));

      // Calcular la fecha actual
      const current = new Date();
      const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                            ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                             current.getFullYear();

      const reqCotizacionData = {
        destino: {
          nombre: "",
          codigo: currentFormValues.city,
        },
        origen: {
          nombre: "",
          codigo: "",
        },
        IdTipoEntrega: 1,
        IdServicio: 1,
        peso: pesoTotal,
        largo: 1,
        ancho: 1,
        alto: 1,
        // Usar la fecha actual
        fecha: formattedDate,
        AplicaContrapago: currentFormValues.aplicaContrapago,
        valorDeclarado: newSubtotal,
        seguro99: seguro99Enabled,
        seguro99plus: seguro99PlusEnabled,
      };

      console.log('Datos para la nueva cotización:', reqCotizacionData);

      const response = await axios.post(
        `https://integration.99envios.app/api/sucursal/cotizar/${idsucursal}`,
        reqCotizacionData
      );
      console.log('Respuesta de la API (requote):', response.data);
      setCotizaciones(response.data);
    } catch (error) {
      console.error('Error al generar la nueva cotización:', error);
    } finally {
      setLoading(false);
    }
  };

  // Actualizar la función calculateTotal
  const calculateTotal = (values) => {
    const subtotal = values.salePrice * values.quantity;
    const shippingCost = transportadora; // Costo de envío
    
    // Si es checkout de carrito, usar la suma de precios de proveedor del carrito
    const supplierCost = isCartCheckout 
      ? cart.reduce((total, item) => total + (item.supplierPrice * item.quantity), 0)
      : (producto.precio_proveedor * values.quantity);
    
    const platformCommission = 0; // Comisión de la plataforma

    // Total es la suma de todo
    const total = subtotal + /*shippingCost +*/ platformCommission;
    
    return total;
  };

  // Cálculo correcto del monto a ganar cuando esté entregado
  const calcularMontoGanar = () => {
    if (isCartCheckout) {
      // Carrito: sumar todos los productos con comisión
      const subtotalCarrito = cart.reduce((total, item) => total + (item.suggestedPrice * item.quantity), 0);
      const totalProveedorCarrito = cart.reduce((total, item) => total + (calcularPrecioConComision(item.supplierPrice) * item.quantity), 0);
      return subtotalCarrito - totalProveedorCarrito - transportadora;
    } else {
      // Producto único: usar precio proveedor con comisión y cantidad
      return (formValues.salePrice * formValues.quantity) - (calcularPrecioConComision(precioProveedor) * formValues.quantity) - transportadora;
    }
  };

  const handleImageClick = (index) => {
    setSelectedImage(index);
    const cotizacion = cotizaciones[envios[index]] || {};
    const valor = cotizacion.valor || 0;
    const valorContrapago = cotizacion.valor_contrapago || cotizacion.valorContrapago || 0;
    const comisionInterna = cotizacion.comision_interna || cotizacion.valor_interna || 0;
    const sobreflete = cotizacion.sobreflete || 0;
    const seguro99 = seguro99Enabled ? (cotizacion.seguro99 || 0) : 0;
    const totalCotizacion = valor + valorContrapago + comisionInterna + sobreflete + seguro99;

    setTransportadora(totalCotizacion);
    form.setFieldsValue({ total: calculateTotal({ ...formValues, salePrice: formValues.salePrice, quantity: inputValue }) });
  };

  const handleCotizarClick = async () => {
    setLoading(true);
    try {
      const formData = await form.validateFields();
      console.log('Formulario completo:', formData);
      console.log('Ciudad seleccionada para cotización:', formData.city);
      
      // Mostrar valores antes de la validación
      console.log('Valores antes de la validación:', form.getFieldsValue());

      // Convertir valores a números antes de validar
      form.setFieldsValue({
        salePrice: Number(formValues.salePrice),
        quantity: Number(formValues.quantity),
      });

      // Mostrar valores después de convertir
      console.log('Valores después de la conversión:', form.getFieldsValue());

      // Validar todos los campos antes de cotizar
      await form.validateFields();

      // Calcular el subtotal con valores numéricos
      const subtotal = Number(formValues.salePrice) * Number(formValues.quantity);
      console.log('Subtotal calculado:', subtotal);

      // Calcular el peso total
      const pesoTotal = isCartCheckout
        ? cart.reduce((total, item) => total + (Number(item.peso_producto || 1) * item.quantity), 0)
        : (Number(producto.peso_producto || props.peso_producto || 1) * Number(formValues.quantity));

      console.log('Peso total a enviar:', pesoTotal); // Para debugging

      // Agrega lo siguiente para obtener la fecha actual
      const current = new Date();
      const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                            ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                             current.getFullYear();

      const cotizacionData = {
        destino: {
          nombre: "",
          codigo: formValues.city,
        },
        origen: {
          nombre: "",
          codigo: "",
        },
        IdTipoEntrega: 1,
        IdServicio: 1,
        peso: pesoTotal,
        largo: 1,
        ancho: 1,
        alto: 1,
        fecha: formattedDate,
        AplicaContrapago: formValues.aplicaContrapago,
        valorDeclarado: subtotal,
        seguro99: seguro99Enabled,
        seguro99plus: seguro99PlusEnabled,
      };

      // Mostrar datos que se enviarán en la petición
      console.log('Datos para la cotización:', cotizacionData);

      // Intentar la petición POST a la API
      const response = await axios.post(
        `https://integration.99envios.app/api/sucursal/cotizar/${idsucursal}`,
        cotizacionData
      );
      console.log('Respuesta de la API:', response.data);
      setCotizaciones(response.data);
      message.success('Cotización generada con éxito');
    } catch (error) {
      // Mostrar mensaje específico si la validación es la que falla
      if (error.errorFields) {
        message.error('Error de validación: revise los campos del formulario.');
        console.error('Error de validación:', error.errorFields);
        console.log('Campos que fallaron la validación:', error.errorFields);
      } else {
        message.error('Error al generar la cotización');
        console.error('Error al generar la cotización:', error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.5 }, // Ajustar la altura para que el confeti aparezca en el modal
        zIndex: 9999, // Asegúrate de que el confeti esté por encima del modal
      });
    }
  }, [isModalVisible]);

  // Reemplazar la función openPDF existente con esta nueva versión
  const openPDF = (pdfUrl) => {
    console.log("openPDF recibió:", pdfUrl);
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    } else {
      message.error('No se encontró la URL del PDF');
    }
  };

  // Función para generar PDF de la guía
  const generatePDF = async (orderResponse, sucursalId) => {
    try {
      const pdfData = {
        id_solicitud: orderResponse.id_solicitud,
        tamano_guia: selectedTamanoGuia
      };

      const pdfResponse = await fetch(
        `https://integration.99envios.app/api/sucursal/pdf/${sucursalId}/${selectedTamanoGuia}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(pdfData),
        }
      );

      if (!pdfResponse.ok) {
        throw new Error('Error al generar PDF');
      }

      const pdfUrl = await pdfResponse.text();
      return pdfUrl;
    } catch (error) {
      console.error('Error al generar PDF:', error);
      return null;
    }
  };

  const handleConfirmarClick = async () => {
    setLoading(true);
    try {
      // Validar que se haya seleccionado una transportadora
      if (selectedImage === null) {
        message.error('Por favor seleccione una transportadora antes de confirmar el pedido');
        setLoading(false);
        return;
      }

      const totalGanar = calcularMontoGanar();
      if (totalGanar < 0) {
        message.error('El monto a ganar es negativo. No puedes confirmar y enviar el pedido.');
        setLoading(false);
        return;
      }

      await form.validateFields();

      if (isCartCheckout) {
        // Agrupar productos por proveedor
        const providerGroups = cart.reduce((acc, item) => {
          if (!acc[item.provider]) {
            acc[item.provider] = [];
          }
          acc[item.provider].push(item);
          return acc;
        }, {});

        const completedOrders = [];

        // Procesar cada grupo de proveedor
        for (const [provider, items] of Object.entries(providerGroups)) {
          const orderData = {
            productos: items.map(item => {
              const comisionPorcentaje = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
              // Calcular la comisión sobre el precio proveedor
              const comision = (item.supplierPrice * comisionPorcentaje) / 100;
              
              return {
                IdProducto: item.id,
                IdVariacion: '',
                valorDeclarado: item.suggestedPrice,
                Cantidad: item.quantity,
                comision: comision
              };
            }),
            AplicaContrapago: formValues.aplicaContrapago,
            Destinatario: {
              nombre: formValues.firstName,
              primerApellido: formValues.lastName.split(' ')[0] || '',
              segundoApellido: formValues.lastName.split(' ')[1] || '',
              telefono: formValues.phone,
              direccion: formValues.address,
              idLocalidad: formValues.city,
              correo: formValues.email
            },
            Observaciones: `${formValues.notes} - Pedido del proveedor: ${provider}`,
            transportadora: {
              pais: 'colombia',
              nombre: envios[selectedImage] || ''
            },
            seguro99: seguro99Enabled,
            seguro99plus: seguro99PlusEnabled,
          };

          const id = localStorage.getItem('usuario_id');
          const token = localStorage.getItem('token');

          const config = {
            headers: {
              'Authorization': token ? `Bearer ${token}` : '',
              'Content-Type': 'application/json'
            }
          };

          try {
            const response = await axios.post(
              `https://99envios.app/api/solicitud-orden/${id}`,
              orderData,
              config
            );

            if (response.status === 200) {
              // Generar PDF después de confirmar la orden
              const pdfUrl = await generatePDF(response.data, idsucursal);
              
              completedOrders.push({
                provider,
                orderResponse: {
                  ...response.data,
                  pdf: pdfUrl // Agregar la URL del PDF a la respuesta
                }
              });

              if (statusWhatsapp && response.data.pdf) {
                const numeroPreenvio = response.data.pdf.split('_').pop().split('.')[0];
                try {
                  await axios.post(
                    `https://99envios.app/api/online/whatsapp/message_template_envios/${numeroPreenvio}`,
                    {}
                  );
                } catch (whatsAppError) {
                  console.error('Error enviando WhatsApp:', whatsAppError);
                }
              }

              message.success(`Pedido para ${provider} procesado correctamente`);
            }
          } catch (orderError) {
            message.error(`Error al procesar el pedido para ${provider}`);
            console.error('Error en pedido:', orderError);
          }
        }

        if (completedOrders.length > 0) {
          setOrderResponse({
            completedOrders,
            totalOrders: Object.keys(providerGroups).length
          });
          setIsModalVisible(true);
          confetti({
            particleCount: 150,
            spread: 70,
            origin: { y: 0.5 }
          });
        }

      } else {
        // Para un solo producto, usar precioProveedor en lugar de salePrice para la comisión
        const comisionPorcentaje = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
        // Calcular la comisión sobre el precio proveedor
        const comision = (precioProveedor * comisionPorcentaje) / 100;

        const orderData = {
          productos: [{
            IdProducto: producto.id_producto,
            IdVariacion: selectedVariation || '',
            valorDeclarado: formValues.salePrice,
            Cantidad: formValues.quantity,
            comision: comision
          }],
          AplicaContrapago: formValues.aplicaContrapago,
          Destinatario: {
            nombre: formValues.firstName,
            primerApellido: formValues.lastName.split(' ')[0] || '',
            segundoApellido: formValues.lastName.split(' ')[1] || '',
            telefono: formValues.phone,
            direccion: formValues.address,
            idLocalidad: formValues.city,
            correo: formValues.email
          },
          Observaciones: formValues.notes,
          transportadora: {
            pais: 'colombia',
            nombre: envios[selectedImage] || ''
          },
          seguro99: seguro99Enabled,
          seguro99plus: seguro99PlusEnabled,
        };

        const id = localStorage.getItem('usuario_id');
        const token = localStorage.getItem('token');

        const response = await axios.post(
          `https://99envios.app/api/solicitud-orden/${id}`,
          orderData,
          {
            headers: {
              'Authorization': token ? `Bearer ${token}` : '',
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.status === 201) {
          // Generar PDF después de confirmar la orden
          const pdfUrl = await generatePDF(response.data, idsucursal);
          
          setOrderResponse({
            ...response.data,
            pdf: pdfUrl // Agregar la URL del PDF a la respuesta
          });
          setIsModalVisible(true);

          if (statusWhatsapp && response.data.pdf) {
            const numeroPreenvio = response.data.pdf.split('_').pop().split('.')[0];
            try {
              await axios.post(
                `https://99envios.app/api/online/whatsapp/message_template_envios/${numeroPreenvio}`,
                {}
              );
            } catch (whatsAppError) {
              console.error('Error enviando WhatsApp:', whatsAppError);
            }
          }

          message.success('Pedido confirmado y enviado con éxito');
        }
      }
    } catch (error) {
      message.error('Error al procesar el pedido');
      console.error('Error general:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleVariationChange = (value) => {
    setSelectedVariation(value);
    const selectedVar = producto.variaciones.find(variation => variation.id === value);
    setInputValue(1);  // Reinicia la cantidad a 1 al cambiar de variación
    form.setFieldsValue({ quantity: 1, salePrice: producto.precio_sugerido });
    message.info(`Seleccionaste la variación con ID: ${value}, Talla: ${selectedVar.talla}, Color: ${selectedVar.color}`);
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    setOrderResponse(null); // Reseteamos la respuesta al cerrar el modal
    form.resetFields(); // Limpiar formulario
    setFormValues({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      notes: '',
      payment: '',
      product: '',
      quantity: 1,
      salePrice: 0,
      store: '',
      aplicaContrapago: true
    });
    setSelectedVariation(null);
    setSelectedImage(null);
    setTransportadora(0);
    setSubtotal(0);
    setSelectedBodega(null);
    setSelectedBodegaStock(null);
    // Llama a onClose si está definido para cerrar el modal padre
    if (props.onClose) {
      props.onClose();
    }
  };


  // Determinar cantidad disponible con manejo seguro de undefined
  const cantidadDisponible = isCartCheckout
    ? null // No es necesario para checkout de carrito
    : (estadoBodega
      ? (selectedBodegaStock || (inventarioBodega?.reduce((acc, b) => acc + (b?.cantidad_disponible || 0), 0) || 0))
      : (producto?.cantidad_disponible || 0));

  const handleBodegaChange = (value) => {
    const bodegaSeleccionada = inventarioBodega.find((bodega) => bodega.id === parseInt(value, 10));
    setSelectedBodega(bodegaSeleccionada);
    setSelectedBodegaStock(bodegaSeleccionada?.cantidad_disponible || 0);
  };

  const MultiProviderAlert = () => (
    <div className="multi-provider-alert">
      <div className="alert-content">
        <h4>⚠️ Aviso Importante</h4>
        <p>Tu carrito contiene productos de {totalProviders} proveedores diferentes.</p>
        <p>Deberás completar {totalProviders} procesos de cotización y envío separados, uno por cada proveedor.</p>
        <p>Esto es necesario porque cada proveedor maneja sus envíos de manera independiente.</p>
        <button 
          className="alert-understand-btn" 
          onClick={() => setShowMultiProviderAlert(false)}
        >
          Entendido, continuar
        </button>
      </div>
    </div>
  );

  const renderOrderModal = () => {
    if (isCartCheckout && orderResponse?.completedOrders) {
      return (
        <Modal
          title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Confirmación de Órdenes</span>}
          visible={isModalVisible}
          onCancel={handleModalOk}
          footer={null}
          centered
          width={800}
        >
          <div style={{ maxHeight: '60vh', overflow: 'auto', padding: '20px' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
              Se han procesado {orderResponse.completedOrders.length} de {orderResponse.totalOrders} pedidos
            </h2>
            {orderResponse.completedOrders.map((order, index) => (
              <div key={index} style={{
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                padding: '15px',
                marginBottom: '15px'
              }}>
                <h3>Pedido {index + 1} - Proveedor: {order.provider}</h3>
                <p><strong>Número de Orden:</strong> {order.orderResponse.numero_orden}</p>
                <Button
                  type="primary"
                  onClick={() => {
                    console.log("Abriendo PDF para proveedor", order.provider, ":", order.orderResponse.pdf);
                    openPDF(order.orderResponse.pdf);
                  }}
                  style={{ marginTop: '10px' }}
                >
                  Ver Guía
                </Button>
              </div>
            ))}
          </div>
        </Modal>
      );
    }

    // Modal original para un solo pedido
    return (
      <Modal
        title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Confirmación de Orden</span>}
        visible={isModalVisible}
        onCancel={handleModalOk}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={handleModalOk}
          >
            Aceptar
          </Button>,
        ]}
        centered
        width={600}
        zIndex={9999}
        bodyStyle={{
          padding: '20px',
          backgroundColor: '#f7f7f7',
          borderRadius: '8px',
        }}
      >
        {orderResponse && (
          <div style={{ lineHeight: '1.6', fontSize: '16px' }}>
            <div style={{ marginBottom: '16px', textAlign: 'center' }}>
              <strong style={{ fontSize: '18px', textDecoration: 'underline' }}>Resumen de la Orden</strong>
            </div>
            <div style={{ marginBottom: '16px' }}>
              {/* Mostrar mensaje de la API si existe */}
              {orderResponse.error && (
                <p><strong>Mensaje:</strong> {orderResponse.error}</p>
              )}
              {/* Mostrar id_solicitud y estado si existen */}
              {orderResponse.id_solicitud && (
                <p><strong>ID Solicitud:</strong> {orderResponse.id_solicitud}</p>
              )}
              {orderResponse.estado && (
                <p><strong>Estado:</strong> {orderResponse.estado}</p>
              )}
              {/* Mostrar número de orden si existe */}
              {orderResponse.numero_orden && (
                <p><strong>Número de Orden:</strong> {orderResponse.numero_orden}</p>
              )}
            </div>
            {(orderResponse.valor_venta || orderResponse.valor_proveedor || orderResponse.valor_envio) && (
              <div style={{
                padding: '10px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                marginBottom: '16px'
              }}>
                {orderResponse.valor_venta && (
                  <p><strong>Valor de Venta:</strong> {formatCurrency(orderResponse.valor_venta)}</p>
                )}
                {orderResponse.valor_proveedor && (
                  <p><strong>Valor de Proveedor:</strong> {formatCurrency(orderResponse.valor_proveedor)}</p>
                )}
                {orderResponse.valor_envio && (
                  <p><strong>Valor de Envío:</strong> {formatCurrency(orderResponse.valor_envio)}</p>
                )}
                {orderResponse.valor_comision && (
                  <p><strong>Valor de Comisión:</strong> {formatCurrency(orderResponse.valor_comision)}</p>
                )}
                {orderResponse.valor_4X100 && (
                  <p><strong>Valor de 4x1000:</strong> {formatCurrency(orderResponse.valor_4X100)}</p>
                )}
                {orderResponse.valor_utilidad && (
                  <p><strong>Utilidad:</strong> {formatCurrency(orderResponse.valor_utilidad)}</p>
                )}
              </div>
            )}
          </div>
        )}
      </Modal>
    );
  };

  // Modificar el renderizado del formulario
  const renderProductSection = () => {
    if (isCartCheckout) {
      // Calcular sumas totales
      const totalSuggestedPrice = cart.reduce((total, item) => 
        total + (item.suggestedPrice * item.quantity), 0);
      const totalSupplierPrice = cart.reduce((total, item) => 
        total + (item.supplierPrice * item.quantity), 0);

      return (
        <>
          <div>
            <h3>Productos en el carrito:</h3>
            {cart.map((item, index) => (
              <div key={index} className="cart-product-item">
                <p>{item.name}</p>
                <p>Cantidad: {item.quantity}</p>
                <p>Precio proveedor: ${item.supplierPrice.toLocaleString()}</p>
                <p>Precio sugerido: ${item.suggestedPrice.toLocaleString()}</p>
              </div>
            ))}
          </div>

          <Text>Precio sugerido: ${totalSuggestedPrice.toLocaleString()}</Text>
          <Form.Item
            label="Precio de venta"
            name="salePrice"
            initialValue={totalSuggestedPrice}
            rules={[{ required: true, message: 'Por favor ingresa el precio de venta' }]}
          >
            <Input type="number" />
          </Form.Item>

        
        </>
      );
    }

    // Para un solo producto mantener el código original
    return (
      <>
        <Form.Item
          label="Producto"
          name="product"
          initialValue={props.name} // Usar props.name
          rules={[{ required: true, message: 'Por favor selecciona un producto' }]}
        >
          <Input disabled />
        </Form.Item>

        {/* Select para Variaciones - Movido aquí */}
        {producto.variaciones.length > 0 && (
          <Form.Item
            name="variation"
            label="Selecciona una variación"
            rules={[{ required: true, message: 'Por favor selecciona una variación' }]}
          >
            <Select placeholder="Selecciona una variación" onChange={handleVariationChange}>
              {producto.variaciones.map(variation => (
                <Option key={variation.id} value={variation.id}>
                  {`ID: ${variation.id}, Talla: ${variation.talla}, Color: ${variation.color}, Stock: ${variation.cantidad_disponible}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {/* Aplica Contrapago - Movido aquí */}
        <Form.Item
          name="aplicaContrapago"
          label="¿Aplica Contrapago?"
          initialValue={true}
        >
          <Radio.Group disabled>
            <Radio value={true}>Sí</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        {/* Seguro Antidevoluciones */}
        <Form.Item
          name="seguro99"
          label={
            <span>
              Seguro Antidevoluciones
              <Tooltip
                title={"🛡️ El valor del seguro será cobrado en caso de generarse una devolución o entrega."}
                placement="right"
                overlayStyle={{ zIndex: 9999 }}
              >
                <QuestionCircleOutlined 
                  style={{ 
                    marginLeft: '8px', 
                    color: '#1890ff',
                    cursor: 'help'
                  }} 
                />
              </Tooltip>
            </span>
          }
          initialValue={seguro99Enabled}
        >
                      <Checkbox
              checked={seguro99Enabled}
              onChange={e => handleSeguro99Change(e.target.checked)}
              style={{ marginRight: '8px', cursor: 'pointer' }}
            >
              Activar Seguro Antidevoluciones
            </Checkbox>
        </Form.Item>

        {/* Seguro Antidevoluciones Plus */}
        <Form.Item
          name="seguro99plus"
          label={
            <span>
              Seguro Antidevoluciones Plus
              <Tooltip
                title={"En caso de una devolución, no asumes ningún costo: no pagas el envío de ida, ni el de regreso, ni el valor del seguro. El costo total es cero."}
                placement="right"
                overlayStyle={{ zIndex: 9999 }}
              >
                <QuestionCircleOutlined 
                  style={{ 
                    marginLeft: '8px', 
                    color: '#1890ff',
                    cursor: 'help'
                  }} 
                />
              </Tooltip>
            </span>
          }
          initialValue={seguro99PlusEnabled}
        >
                      <Checkbox
              checked={seguro99PlusEnabled}
              onChange={e => handleSeguro99PlusChange(e.target.checked)}
              style={{ marginRight: '8px', cursor: 'pointer' }}
            >
              Activar Seguro Antidevoluciones Plus
            </Checkbox>
        </Form.Item>

        <Text>Precio sugerido: ${calcularPrecioConComision(props.suggestedPrice).toLocaleString()}</Text>
        <Text>Precio proveedor: ${calcularPrecioConComision(props.precioProveedor || 0).toLocaleString()}</Text>
        <Form.Item
          label="Precio de venta"
          name="salePrice"
          initialValue={calcularPrecioConComision(props.suggestedPrice)}
          rules={[{ required: true, message: 'Por favor ingresa el precio de venta' }]}
        >
          <Input type="number" />
        </Form.Item>

        <Text>Stock disponible: {props.stock}</Text>
        
      </>
    );
  };

  return (
    <Spin spinning={loading}>
      {showMultiProviderAlert && isCartCheckout && <MultiProviderAlert />}
      <div className="enviosDrop">
        <div className="formularioEnvio">
          <Form form={form} layout="vertical" onValuesChange={onValuesChangePedido}>
            <Form.Item
              name="firstName"
              label="Nombre(s) destinatario"
              rules={[{ required: true, message: 'Por favor ingrese el nombre del destinatario' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="lastName"
              label="Apellido(s) destinatario"
              rules={[{ required: true, message: 'Por favor ingrese el apellido del destinatario' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Teléfono destinatario"
              rules={[{ required: true, message: 'Por favor ingrese el teléfono del destinatario' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email destinatario (Opcional)"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="address"
              label="Dirección destinatario"
              rules={[{ required: true, message: 'Por favor ingrese la dirección del destinatario' }]}
            >
              <Input.TextArea />
            </Form.Item>

            <Form.Item
              name="city"
              label="Ciudad destinatario"
              rules={[{ required: true, message: 'Seleccione la ciudad del destinatario' }]}
            >
              <Select
                showSearch
                placeholder="Seleccione una ciudad"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return option?.children?.toString().toLowerCase().includes(input.toLowerCase());
                }}
                onChange={(value) => {
                  console.log('Ciudad seleccionada:', value);
                  setFormValues(prev => ({
                    ...prev,
                    city: value
                  }));
                }}
              >
                {Array.isArray(Ciudades) ? (
                  Ciudades.map((ciudad) => (
                    <Option key={ciudad.value} value={ciudad.value}>
                      {ciudad.label}
                    </Option>
                  ))
                ) : (
                  <Option value="">No hay ciudades disponibles</Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="notes"
              label="Notas para el Proveedor"
              rules={[{ required: true, message: 'Por favor ingrese alguna nota' }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Button type="primary" onClick={handleCotizarClick} block>
              Cotizar
            </Button>
          </Form>
        </div>

        <div className="transportadora">
          {/* Selector de tamaño de guía */}
          <div className="tamano-guia-container" style={{ marginBottom: '16px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontWeight: '500',
              color: '#333',
              fontSize: '14px'
            }}>
              Tamaño de Guía:
            </label>
            <Select
              value={selectedTamanoGuia}
              onChange={(value) => setSelectedTamanoGuia(value)}
              style={{ width: '100%' }}
              size="large"
            >
              <Option value="1">Sticker</Option>
              <Option value="2">Media Carta</Option>
            </Select>
          </div>
          
          {images.map((image, index) => {
            const cotizacion = cotizaciones[envios[index]] || {};
            const valor = cotizacion.valor || 0;
            const valorContrapago = cotizacion.valor_contrapago || cotizacion.valorContrapago || 0;
            const comisionInterna = cotizacion.comision_interna || cotizacion.valor_interna || 0;
            const sobreflete = cotizacion.sobreflete || 0;
            const seguro99 = seguro99Enabled ? (cotizacion.seguro99 || 0) : 0;
            const totalCotizacion = valor + valorContrapago + comisionInterna + sobreflete + seguro99;

            return (
              <div
                key={index}
                className="flete"
                style={{
                  border: selectedImage === index ? '1px solid rgba(247, 118, 67, 0.5)' : '1px solid rgba(128, 128, 128, 0.5)',
                  cursor: 'pointer'
                }}
                onClick={() => handleImageClick(index)}
              >
                <img src={image} alt={`Imagen ${index + 1}`} />
                <p>{formatCurrency(totalCotizacion)}</p>
              </div>
            );
          })}
        </div>

        <div className="pedidoEnvio">
          <Form form={form} layout="vertical" onValuesChange={onValuesChangePedido}>
            {renderProductSection()}
            
            <Form.Item
              label="Cantidad"
              name="quantity"
              initialValue={1}
              rules={[
                { required: true, message: 'Por favor ingresa la cantidad' },
                {
                  validator: (_, value) => {
                    if (isCartCheckout) {
                      return Promise.resolve();
                    }
                    // Use warehouse stock if estadoBodega true; otherwise, use product stock.
                    const maxStock = estadoBodega 
                      ? selectedBodegaStock 
                      : (producto?.cantidad_disponible || props.stock);
                    
                    if (estadoBodega && (maxStock === undefined || maxStock === null)) {
                      return Promise.reject('Seleccione una bodega o revise el stock disponible');
                    }
                    return (value < 1 || value > maxStock)
                      ? Promise.reject(`La cantidad debe estar entre 1 y ${maxStock}`)
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                type="number"
                value={inputValue}
                onChange={(e) => handleChange(Number(e.target.value))}
                disabled={isCartCheckout} // Disable input for cart checkout
              />
            </Form.Item>

            {estadoBodega && (
              <div>
                <label name="bodega" rules={[{ required: estadoBodega, message: 'Seleccione una bodega' }]}>Bodega disponible:</label>
                <Select placeholder="Seleccione una bodega" onChange={handleBodegaChange}>
                  {inventarioBodega.map((bodega) => (
                    <Option key={bodega.id} value={bodega.id}>
                      {bodega.ciudad_bodega} (Stock: {bodega.cantidad_disponible})
                    </Option>
                  ))}
                </Select>
              </div>
            )}

            {/* {estadoBodega && inventarioBodega.length > 0 && (
              <div>
                <label>Selecciona bodega:</label>
                <select onChange={handleBodegaChange} defaultValue="">
                  <option value="" disabled>-- Elige una bodega --</option>
                  {inventarioBodega.map((bodega) => (
                    <option key={bodega.id} value={bodega.id}>
                      {bodega.ciudad_bodega} (Stock: {bodega.cantidad_disponible})
                    </option>
                  ))}
                </select>
              </div>
            )} */}

          </Form>
          <div className="order-summary">
            <div className="order-summary-header">Resumen de la orden</div>
            <div className="order-summary-content">
              <div className="order-summary-item">
                <div className="item-description">{formValues.product}</div>
                <div className="item-price">{formatCurrency(formValues.salePrice)} x {formValues.quantity}</div>
              </div>
              <div className="order-summary-total">
                <div className="total-label">Sub Total :</div>
                <div className="total-amount">{formatCurrency(formValues.salePrice * formValues.quantity)}</div>
              </div>
              {/* precio proveedor */}
              <div className="order-summary-total">
                <div className="total-label">Precio Proveedor :</div>
                <div className="total-amount">
                  {isCartCheckout 
                    ? formatCurrency(
                      cart.reduce((total, item) => 
                        total + (calcularPrecioConComision(item.supplierPrice) * item.quantity), 0)
                    )
                    : formatCurrency(calcularPrecioConComision(precioProveedor) * formValues.quantity)
                  }
                </div>
              </div>
              {/* precio de envio con las sumas */}

              <div className="order-summary-total">
                <div className="total-label">Precio de Envío :</div>
                <div className="total-amount">
                  {(() => {
                    if (selectedImage !== null) {
                      const cotizacion = cotizaciones[envios[selectedImage]] || {};
                      const valor = cotizacion.valor || 0;
                      const valorContrapago = cotizacion.valor_contrapago || cotizacion.valorContrapago || 0;
                      const comisionInterna = cotizacion.comision_interna || cotizacion.valor_interna || 0;
                      const sobreflete = cotizacion.sobreflete || 0;
                      const seguro99 = seguro99Enabled ? (cotizacion.seguro99 || 0) : 0;
                      const totalCotizacion = valor + valorContrapago + comisionInterna + sobreflete + seguro99;
                      return formatCurrency(totalCotizacion);
                    }
                    return formatCurrency(0);
                  })()}
                </div>
              </div>

              <div className="order-summary-total">
                <div className="total-label">Comisión de la plataforma :</div>
                <div className="total-amount">$ 0</div>
              </div>

              <div className="order-summary-total">
                <div className="total-label">Monto a ganar cuando esté entregado :</div>
                <div className="total-amount" style={{ color: calcularMontoGanar() < 0 ? 'red' : 'black' }}>
                  {formatCurrency(calcularMontoGanar())}
                </div>
              </div>
              {calcularMontoGanar() < 0 && (
                <div style={{ color: 'red', marginTop: '10px' }}>
                  <strong>Advertencia:</strong> El monto a ganar es negativo. No puedes confirmar y enviar el pedido.
                </div>
              )}

              <div className="order-summary-total">
                <div className="total-label">Total a cobrar al cliente:</div>
                <div className="total-amount">{formatCurrency(calculateTotal(formValues))}</div>
              </div>
              <div className="order-summary-footer">
                <Button
                  type="primary"
                  onClick={handleConfirmarClick}
                  block
                  disabled={calcularMontoGanar() < 0 || selectedImage === null}
                >
                  {selectedImage === null 
                    ? 'Seleccione una transportadora' 
                    : calcularMontoGanar() < 0 
                      ? 'No se puede confirmar - Monto negativo'
                      : 'Confirmar y Enviar Pedido'}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Confirmación de Orden</span>}
          visible={isModalVisible}
          onCancel={handleModalOk}
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={handleModalOk}
            >
              Aceptar
            </Button>,
            <Button
              key="pdf"
              type="primary"
              onClick={() => {
                if (orderResponse?.pdf) {
                  window.open(orderResponse.pdf, '_blank');
                }
              }}
              disabled={!orderResponse?.pdf}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            >
              Ver Guía
            </Button>
          ]}
          centered
          width={600}
          zIndex={9999}
          bodyStyle={{
            padding: '20px',
            backgroundColor: '#f7f7f7',
            borderRadius: '8px',
          }}
        >
          {orderResponse && (
            <div style={{ lineHeight: '1.6', fontSize: '16px' }}>
              <div style={{ marginBottom: '16px', textAlign: 'center' }}>
                <strong style={{ fontSize: '18px', textDecoration: 'underline' }}>Resumen de la Orden</strong>
              </div>
              <div style={{ marginBottom: '16px' }}>
                {/* Mostrar mensaje de la API si existe */}
                {orderResponse.error && (
                  <p><strong>Mensaje:</strong> {orderResponse.error}</p>
                )}
                {/* Mostrar id_solicitud y estado si existen */}
                {orderResponse.id_solicitud && (
                  <p><strong>ID Solicitud:</strong> {orderResponse.id_solicitud}</p>
                )}
                {orderResponse.estado && (
                  <p><strong>Estado:</strong> {orderResponse.estado}</p>
                )}
                {/* Mostrar número de orden si existe */}
                {orderResponse.numero_orden && (
                  <p><strong>Número de Orden:</strong> {orderResponse.numero_orden}</p>
                )}
              </div>
              {(orderResponse.valor_venta || orderResponse.valor_proveedor || orderResponse.valor_envio) && (
                <div style={{
                  padding: '10px',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                  marginBottom: '16px'
                }}>
                  {orderResponse.valor_venta && (
                    <p><strong>Valor de Venta:</strong> {formatCurrency(orderResponse.valor_venta)}</p>
                  )}
                  {orderResponse.valor_proveedor && (
                    <p><strong>Valor de Proveedor:</strong> {formatCurrency(orderResponse.valor_proveedor)}</p>
                  )}
                  {orderResponse.valor_envio && (
                    <p><strong>Valor de Envío:</strong> {formatCurrency(orderResponse.valor_envio)}</p>
                  )}
                  {orderResponse.valor_comision && (
                    <p><strong>Valor de Comisión:</strong> {formatCurrency(orderResponse.valor_comision)}</p>
                  )}
                  {orderResponse.valor_4X100 && (
                    <p><strong>Valor de 4x1000:</strong> {formatCurrency(orderResponse.valor_4X100)}</p>
                  )}
                  {orderResponse.valor_utilidad && (
                    <p><strong>Utilidad:</strong> {formatCurrency(orderResponse.valor_utilidad)}</p>
                  )}
                </div>
              )}
            </div>
          )}
        </Modal>

        {/* Modal de advertencia para seguro deshabilitado por porcentaje */}
        <Modal
                            open={isVisibleModalWarning}
                            centered
                            width={480}
                            className="seguro99-warning-modal"
                            footer={null}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                color: "#f5a623",
                                marginBottom: "0",
                              }}
                            >
                              <WarningOutlined style={{ fontSize: "20px" }} />
                              <span style={{ fontSize: "16px", fontWeight: "500" }}>
                                Seguro Antidevoluciones desactivado
                              </span>
                            </div>
                            <div
                              style={{
                                marginTop: "16px",
                                background: "#fff9e6",
                                padding: "16px",
                                borderRadius: "8px",
                                border: "1px solid #ffd666",
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  color: "#595959",
                                  fontSize: "14px",
                                  textAlign: "center",
                                  lineHeight: "1.5",
                                }}
                              >
                                🚨 Hola! Desde 99envíos.com queremos contarte algo importante: Hemos
                                notado que tu cuenta ha superado el porcentaje de devoluciones
                                aceptable para mantener activo el seguro antidevolución 🛡 Para
                                ayudarte a mejorar ese indicador y recuperar el beneficio, te
                                invitamos a una capacitación personalizada 📚 👉 Ingresa aquí para
                                agendarla: <a href="https://99envios.app/dashboard99?seguro99=true">{/* https://99envios.com/capacitacion/ */}Click aquí</a>{" "} <br />Con gusto te apoyamos
                                para que puedas seguir enviando con todas las ventajas que te ofrece
                                nuestra plataforma 
                              </p>
                              <div style={{display:'flex', justifyContent:'center', marginTop:'20px'}}>
                              <Button style={{backgroundColor: '#f5a623',
                                  borderColor: '#f5a623',
                                  borderRadius: '4px',
                                  height: '32px',
                                  fontWeight: '500'}} 
                                  type="primary"
                                  onClick={() => {
                                     setIsVisibleModalWarning(false);
                                     setSeguro99Enabled(false);
                                     form.setFieldsValue({ seguro99: false });
                                     setFormValues(prev => ({ ...prev, seguro99: false }));
                                 }}
                                  >
                                Ententido
                              </Button>
                              </div>
                            </div>
                          </Modal>
       {/*  <Modal
          title={
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#d48806',
              fontSize: '16px',
              fontWeight: '500'
            }}>
              <WarningOutlined />
              Seguro No Disponible
            </div>
          }
          visible={isVisibleModalWarning}
          onCancel={() => setIsVisibleModalWarning(false)}
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={() => setIsVisibleModalWarning(false)}
              style={{
                backgroundColor: '#d48806',
                borderColor: '#d48806',
                borderRadius: '6px',
                height: '36px',
                fontWeight: '500'
              }}
            >
              Entendido
            </Button>
          ]}
          centered
          width={480}
          maskClosable={true}
        >
          <div style={{
            padding: '20px',
            background: '#fffbe6',
            borderRadius: '8px',
            border: '1px solid #ffe58f'
          }}>
            <div style={{
              color: '#666',
              textAlign: 'center',
              fontSize: '14px',
              lineHeight: '1.6'
            }}>
              <p style={{ marginBottom: '16px' }}>
                El Seguro Antidevoluciones no está disponible para tu sucursal debido a un alto porcentaje de devoluciones.
              </p>
              <p style={{ marginBottom: '16px' }}>
                Para reactivar esta opción, necesitas mejorar tu tasa de entregas exitosas.
              </p>
              <div style={{
                padding: '12px',
                background: '#fff',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: '#1890ff'
              }}>
                <BulbOutlined />
                <div>
                  <strong>Recomendación:</strong> Revisa tus procesos de entrega y comunicación con clientes para reducir devoluciones.
                </div>
              </div>
            </div>
          </div>
        </Modal> */}
      </div>
    </Spin>
  );
};

export default SendClientPage;
